import { DataSourceField } from 'types/dataSourcesTypes';
import { translateField } from 'utils/common';
import { TFunction } from 'i18next';

export const NAME = 100;
export const CONTACT_NAME = 50;
export const CONTACT_EMAIL = 50;
export const EMAIL_REGEX_VALIDATION = /^\S+@\S+$/i;
export const URL_REGEX_VALIDATION =
  /^(?:(https?|ftp|mailto):\/\/)?(?:[a-zA-Z0-9._%+-]+(?::[^\s@]*)?@)?(?:localhost|\d{1,3}(?:\.\d{1,3}){3}|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(?::\d{1,5})?(?:\/[^\s]*)?$/;

/**
 * Returns the subset of `fields` that match `query`, using translated text
 * so the UI can stay fully i18n‑aware while we keep the data request simple.
 */
export const filterDataSourceFields = (
  fields: DataSourceField[],
  query: string,
  t: TFunction,
  mappedValues: Record<string, string> = {}
): DataSourceField[] => {
  const q = query.trim().toLowerCase();
  if (!q) return fields; // nothing to filter

  return fields.filter(field => {
    // ---- translated name ----
    const name = translateField(t, field.fieldKey ?? field.name, {
      subKey: 'field_name',
      by: 'key',
    }).toLowerCase();

    // ---- type label ----
    const typeText = t(
      `data-tables.field-types.${field.fieldType.toLowerCase()}`
    ).toLowerCase();

    // ---- mapped column ----
    const mapped = (
      mappedValues[field.id] ??
      field.sourceColumnName ??
      ''
    ).toLowerCase();

    return name.includes(q) || typeText.includes(q) || mapped.includes(q);
  });
};
